// extracted by mini-css-extract-plugin
export default {"OrderScreen":"OrderScreen_OrderScreen__Y21WM","Heading":"OrderScreen_Heading__Ygf1-","Icon":"OrderScreen_Icon__DbAg1","Button":"OrderScreen_Button__kZuOC"};